<div class="registration-shipping-address">
  <h2>{{ 'fgbcl.registration.shipping.address.title' | translate }}</h2>
  <p class="message">{{ 'fgbcl.registration.shipping.address.info' | translate }}</p>

  <fgbcl-errors></fgbcl-errors>

  <div class="form-container">
    <form [formGroup]="shippingForm">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="FirstName">
            {{ 'fgbcl.registration.shipping.address.fname.label' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            id="FirstName"
            class="form-control"
            type="text"
            formControlName="FirstName"
            [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.FirstName.errors }"
            required
          />
          <div class="invalid-feedback">{{ 'fgbcl.registration.shipping.address.fname.invalid.text' | translate }}</div>
        </div>
  
        <div class="form-group col-md-6">
          <label for="Surname">
            {{ 'fgbcl.registration.shipping.address.lastname.label' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            id="Surname"
            class="form-control"
            type="text"
            formControlName="Surname"
            [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.Surname.errors }"
            required
          />
          <div class="invalid-feedback">{{ 'fgbcl.registration.shipping.address.lastname.invalid.text' | translate }}</div>
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="EmailAddress">
            {{ 'fgbcl.registration.shipping.address.email.label' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            id="EmailAddress"
            class="form-control"
            type="text"
            formControlName="EmailAddress"
            [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.EmailAddress.errors }"
            required
          />
          <div class="invalid-feedback">{{ 'fgbcl.registration.shipping.address.email.invalid.text' | translate }}</div>
        </div>
  
        <div class="form-group col-md-6">
          <label for="HomeNumber">
            {{ 'fgbcl.registration.shipping.address.phone.label' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            id="HomeNumber"
            class="form-control"
            name="HomeNumber"
            type="tel"
            formControlName="HomeNumber"
            [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.HomeNumber.errors }"
            required
          />
          <div class="invalid-feedback">{{ 'fgbcl.registration.shipping.address.phone.invalid.text' | translate }}</div>
        </div>
      </div>
  
      <div class="form-group mt-2">
        <label for="Street">
          {{ 'fgbcl.registration.shipping.address.street.label' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          id="Street"
          class="form-control"
          name="Street"
          type="text"
          formControlName="Street"
          [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.Street.errors }"
          required
        />
        <div class="invalid-feedback">{{ 'fgbcl.registration.shipping.address.street.invalid.text' | translate }}</div>
      </div>
  
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="Town">
            {{ 'fgbcl.registration.shipping.address.city.label' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            id="Town"
            class="form-control"
            name="Town"
            type="text"
            formControlName="Town"
            [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.Town.errors }"
            required
          />
          <div class="invalid-feedback">{{ 'fgbcl.registration.shipping.address.city.invalid.text' | translate }}</div>
        </div>
  
        <div class="form-group col-md-6">
          <label for="County">
            {{ 'fgbcl.registration.shipping.address.state.label' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            id="County"
            class="form-control"
            name="County"
            type="text"
            formControlName="County"
            [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.County.errors }"
            required
          />
          <div class="invalid-feedback">{{ 'fgbcl.registration.shipping.address.state.invalid.text' | translate }}</div>
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="Postcode">
            {{ 'fgbcl.registration.shipping.address.zipcode.label' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            id="Postcode"
            class="form-control"
            name="Postcode"
            type="text"
            formControlName="Postcode"
            [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.Postcode.errors }"
            required
          />
          <div class="invalid-feedback">{{ 'fgbcl.registration.shipping.address.zipcode.invalid.text' | translate }}</div>
        </div>
  
        <div class="form-group col-md-6">
          <label for="Country">
            {{ 'fgbcl.registration.shipping.address.country.label' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            id="Country"
            class="form-control"
            name="Country"
            type="text"
            formControlName="Country"
            [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.Country.errors }"
            required
          />
          <div class="invalid-feedback">{{ 'fgbcl.registration.shipping.address.country.invalid.text' | translate }}</div>
        </div>
      </div>
    </form>
  </div>

  <div class="mt-auto">
    <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
  </div>
</div>